<vi-card *ngrxLet="dashboardStore.loading$ as loading">
  <div title class="flex flex-row justify-between">
    <h2 data-at-title>{{ '+DASHBOARD.DASHBOARD_CONFIGURATION_MODAL.TITLE' | translate }}</h2>
    <mat-icon *ngIf="!loading" (click)="onCancel()" class="close-icon">close</mat-icon>
  </div>
  <div body data-at-body class="flex flex-col content-body gap-[24px]">
    <ng-container *ngIf="!loading; else loader">
      <div
        class="tiles-list"
        cdkDropList
        cdkDropListOrientation="vertical"
        (cdkDropListDropped)="drop($event)"
      >
        <ng-container *ngFor="let tile of tiles; trackBy: trackBy">
          <div
            *ngIf="!tile.concealed"
            class="drag-item"
            cdkDrag
            cdkDragLockAxis="y"
            cdkDragPreviewClass="tile-drag-preview"
            cdkDragPreviewContainer="parent"
            [cdkDragDisabled]="!(uiService.isMobileView$ | async)"
          >
            <mat-checkbox [(ngModel)]="tile.visible" (change)="onCheckboxChange()">
              {{ tile.type | dashboardTileName }}
            </mat-checkbox>
            <div class="drag-handle-wrapper">
              <mat-icon cdkDragHandle>reorder</mat-icon>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <div
    *ngIf="!loading"
    footer
    data-at-footer
    class="flex flex-row justify-between items-center lg:flex-row lt-sm:flex-col-reverse lt-sm:gap-y-2"
  >
    <button
      data-at-cancel-btn
      mat-button
      color="primary"
      gtm="onActivateHolidayProgramNo"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <div
      [matTooltip]="
        '+DASHBOARD.DASHBOARD_CONFIGURATION_MODAL.SAVE_SETTINGS.SAVING_DISABLED' | translate
      "
      [matTooltipDisabled]="!isSavingDisabled"
    >
      <button
        [disabled]="isSavingDisabled"
        data-at-change-btn
        mat-raised-button
        color="primary"
        gtm="onActivateHolidayProgramYes"
        (click)="onSave()"
      >
        {{ 'GENERAL.BUTTON.SAVE_SETTINGS' | translate }}
      </button>
    </div>
  </div>
</vi-card>

<ng-template #loader>
  <vi-loader data-at-loader-dashboard-settings [isLoading]="true"></vi-loader>
</ng-template>
